<template>
  <!-- Group -->
  <div v-if="group_type == group.group_type_id || group_type == 0" class="card p-4 mb-3 mb-md-1 daentreprise_group_type" :class="'daentreprise_group_type'+group.group_type_id">
    <div class="row align-items-sm-center">
      <div class="col">
        <div class="media align-items-center">
          <div class="min-w-8rem mr-2">
            <figure class="text-center">
              <i class="fas fa-users"></i>
            </figure>
          </div>

          <div class="media-body">
            <a
                :href="'/module/daentreprise/group?group_id=' + group.id">
              <h4 class="mb-0 text">
                {{ group.name }}
              </h4>
            </a>

            <span class="font-size-1">
								{{ group.group_type_name }}
							</span>
          </div>
        </div>
      </div>

      <div class="col-sm-7 col-md-5">
        <span class="font-size-1">{{ group.members_count }} membre(s) - </span>
        <span v-if="group.private_registration == 1" class="font-size-1">Accès privé</span>
        <span v-else class="font-size-1">Accès public</span>
        <br>
        <span class="font-size-1">Votre statut : {{ human_status }}</span>
      </div>

      <div class="col-12 col-md col-lg-4 col-xl-3 text-center text-lg-right text-sm-center mt-3 mt-lg-0 ">

        <form method="post" class="d-inline">
          <input type="hidden" name="group_id" :value="group.id">

          <button v-if="status === undefined" class="btn btn-success mr-1" type="submit" name="joinGroup"
                  data-tooltip="tooltip"
                  :title="group.private_registration === '1' ? 'Faire une demande d\'ajout au groupe': 'Rejoindre le groupe'">
            <i class="fa fa-plus"></i>
          </button>

          <button v-else class="btn btn-success mr-1" type="submit" name="quitGroup"
                  data-tooltip="tooltip"
                  title="Quitter le groupe">
            <i class="fa fa-minus"></i>
          </button>

        </form>

        <button
            v-if="admin || customer_id === parseInt(group.owner, 10)"
            class="btn btn-primary mr-1" type="button" data-toggle="modal"
            data-tooltip="tooltip" title="Modifier le groupe"
            v-on:click="$emit('edit_group', group)">
          <i class="fa fa-edit"></i>
        </button>

        <a
            v-if="admin || customer_id === parseInt(group.owner, 10)"
            :href="'/module/daentreprise/mygroupmembers?group_id=' + group.id" data-tooltip="tooltip"
            title="Gérer les membres" class="btn btn-secondary mr-1">
          <i class="fa fa-users"></i>
        </a>

        <button
            v-if="admin || customer_id === parseInt(group.owner, 10)"
            class="btn btn-danger mr-1" type="submit" name="deleteGroup" data-tooltip="tooltip"
            title="Supprimer le groupe"
            v-on:click="$emit('delete_group', group.id)">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
  <!-- Group -->
</template>


<script>

export default {

  props: {
    admin: Number,
    customer_id: Number,
    group: Object,
    status: Number,
    group_type: Number
  },

  data: function () {
    return {}
  },

  computed: {
    human_status: function () {
      let result;

      switch (this.status) {
        case 0:
          result = 'Membre'
          break;
        case 1:
          result = 'Administrateur'
          break;
        case 2:
          result = 'Observateur'
          break;
        case 3:
          result = 'Attente de validation'
          break;
        default:
          result = ''
      }

      return result;
    }
  },

  mounted() {
  },

  methods: {}
}

</script>
